import calls from '@/backend/api-calls'

const state = () => ({
  rfqs: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    project_id: null,
    product_brand: 'Mitrex',
    has_rfqs: true,
    project_name: null
  }
})

// getters
const getters = {
  ids: state => {
    return [].concat.apply([],
      state.rfqs.map(project => {
      return project.rfqs;
    })).map(d => d.id);
  }
}

// actions
const actions = {
  getRfqs: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.projects.get(parameters)
        .then(resp => {
          commit("setRfqs", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addRfq({commit}, data) {
    return new Promise((resolve, reject) => {
      calls.rfqs.post(data)
        .then(resp => {
          commit("insertRfq", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateRfq: ({commit}, { rfqId, data }) => {
    return new Promise((resolve, reject) => {
      calls.rfq.put(rfqId, data).then(
        resp => {
          commit("insertUpdatedRfq", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Rfq successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteRfq: ({commit}, rfqId) => {
    return new Promise((resolve, reject) => {
      calls.rfq.delete(rfqId).then(
        resp => {
          commit("removeRfq", rfqId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Rfq successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  duplicateRfq: ({commit}, {rfqId, data}) => {
    return new Promise((resolve, reject) => {
      calls.cladifyRfq.duplicate(rfqId, data).then(
        resp => {
          commit("insertRfq", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Rfq successfully duplicated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addEstimation: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.cladifyEstimations.post(data).then(
        resp => {
          commit("insertEstimation", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setRfqs(state, data) {
    state.pagination = data.pagination;
    state.rfqs = data.results;
  },
  insertRfq(state, data) {
    state.rfqs.forEach(project => {
      if (project.id == data.project_id) {
        project.rfqs.unshift(data);
      }
    })
  },
  insertUpdatedRfq(state, data) {
    state.rfqs.forEach(project => {
      if (project.id == data.project_id) {
        project.rfqs.forEach((rfq, rfqIndex) => {
          if (rfq.id == data.id) {
            project.rfqs.splice(rfqIndex, 1, data)
          }
        })
      }
    })
  },
  removeRfq(state, rfqId) {
    state.rfqs.forEach(project => {
      let rfqIndex = project.rfqs.map(d => d.id).indexOf(rfqId);
      if (rfqIndex != -1) {
        project.rfqs.splice(rfqIndex, 1);
        const index = state.selected.indexOf(rfqId);
        if (index != -1) {
          state.selected.splice(index, 1);
        }
      }
    })
  },
  insertEstimation(state, data) {
    state.rfqs.forEach(project => {
      let rfqIndex = project.rfqs.map(d => d.id).indexOf(data.project_rfq_id);
      if (rfqIndex != -1) {
        project.rfqs[rfqIndex].c_estimation = data;
      }
    })
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  },
  addHighlightToRfq(state, data) {
    state.rfqs.forEach(project => {
      let rfqIndex = project.rfqs.map(d => d.id).indexOf(data.project_rfq_id);
      if (rfqIndex != -1) {
        project.rfqs[rfqIndex].drawing_highlights.push(data);
        project.rfqs[rfqIndex].has_drawing_highlights = true;
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}